import { Toast as HefestoToast } from '@gerdau/hefesto/Toast';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { removeToast } from '../../../store/ducks/toast/actions';
import { IToast } from '../../../store/ducks/toast/types';

interface IToastMessageProps {
  message: IToast;
}

const Toast: React.FC<IToastMessageProps> = ({ message }) => {
  const dispatch = useDispatch();
  const [closed, setClosed] = useState(false);

  const closeMessage = (durationInMS: number) => {
    setTimeout(() => {
      handleCloseMessage();
    }, durationInMS);
  };

  const handleCloseMessage = () => {
    setClosed(true);
    dispatch(removeToast(message));
  };

  useEffect(() => {
    if (message.durationInMS) {
      closeMessage(message.durationInMS);
    }

    if (message.analyticsTag) {
      dispatch(sendTagging(message.analyticsTag));
    }
  }, []);

  return (
    <>
      {!closed && (
        <HefestoToast
          key={message.id}
          actionOne={{
            label: message.labelActionOne ?? 'Fechar',
            onClick: () => {
              handleCloseMessage();
              message.handleClickActionOne && message.handleClickActionOne();
            }
          }}
          actionTwo={
            message.labelActionTwo
              ? {
                  label: message.labelActionTwo,
                  onClick: () => {
                    handleCloseMessage();
                    message.handleClickActionTwo &&
                      message.handleClickActionTwo();
                  }
                }
              : undefined
          }
          text={
            typeof message.message === 'string'
              ? message.message.toString()
              : ''
          }
          variant={message.type}
          onClose={handleCloseMessage}
          spaceToPageTop={message.spaceToTop ?? 120}
        />
      )}
    </>
  );
};

export default Toast;
